import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '../../../../shared/shared.module';
import { ContactService } from '../../services/contact.service';

@Component({
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {
  contactForm: UntypedFormGroup;

  constructor(
    private contactService: ContactService,
    private matDialog: MatDialog,
  ) {}

  ngOnInit() {
    this.contactForm = new UntypedFormGroup({
      d: new FormControl('', []),
      senderName: new UntypedFormControl('', Validators.required),
      senderEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
      messageText: new UntypedFormControl('', Validators.required),
    });
  }

  onSubmit() {
    if (this.contactForm.valid) {
      let emailForm = this.contactForm.value;
      this.contactService.sendEmail(emailForm);
    } else {
      console.log('your form is not valid');
    }
  }

  close() {
    this.matDialog.closeAll();
  }
}
